export const DATA_POSTE = [
  {
    nom_poste: "Chef d'equipe",
    form_id: "Qualification_CE_2025_4",
    link: "https://volontariat-test.fid-server.org/f/T9wLoIwwHKr5pPh6jh9kcTO3TBTRO4H?st=ZhcWsbJVTpr8i!6JyboW0FHfbe3Vi3W7zSovtYWCHl6nFsP23NF1Uz53siafaHl0",
  },
  {
    nom_poste: "Operateur de saisi",
    form_id: "Qualification_OS_2025_2",
    link: "https://volontariat-test.fid-server.org/f/hnQ1dMTu1sEtVdolHMiDWhLkdd3T1Kz?st=MuanoNcaQwXh8uTBEV4Zr!Bz9AdJ25fs1ETnKpw1cnviefp05ddLEGKVR8uy7buk",
  },
  {
    nom_poste: "Chef de mission",
    form_id: "Qualification_CM_2024_3",
    link: "https://volontariat-test.fid-server.org/f/DV0GveIR9EgB44Oy766U9y77pW01h9o?st=tZuBTqegdhB9RkzTM1!xfBwoLWW0ntDriZpkLcfyXU1NWcD$i5U0f2wQx1Yogl89",
  },
  {
    nom_poste: "Redacteur",
    form_id: "Qualification_Vol_Redac_2025_2",
    link: "https://volontariat-test.fid-server.org/f/GoF2ROYhypG3IKQyCppG3P0CU2QAOrT?st=sTUjXyIaQqjkim3JeoMwuKrRVMRzoV2VoOFeK6a9rXztIRP$$MN2GfSaMhHDCxp3",
  },
];

export const ODK_ASSOCIATION_FORM={
  link: "https://volontariat-test.fid-server.org/f/0Ggpot2c2xdjsj79pHmbpMRcWEh5wzf?st=5af5VPU6htwI0kPQtUGb2auJN6MUIMI70JjNOJ6JI9tst!oCEba89L!4yumEGoVy",
  form_id : "Assoc_TEST_3"
}
